import React, { useMemo } from 'react';
import { Switch, Redirect } from 'react-router-dom';

import { Route } from '@molecules';
import { extractRoutes } from '@utilities';

const mapItemsAsRoutes = (menuItems: AppRouteSingleType[]) => {
  return menuItems.map(route => {
    if (!route.component) return null;

    const { pageTitle, menuTitle } = route;
    return (
      <Route
        {...route}
        exact
        key={route.url}
        path={route.url}
        title={pageTitle !== false ? pageTitle || menuTitle : ''}
      />
    );
  });
};

const AutoRedirect = () => {
  return <Redirect to="/analytics" />;
};

const Routes: React.FC<{ routes: AppRouteType[] }> = ({ routes }) => {
  const simpleRoutes = useMemo(() => extractRoutes(routes), [routes]);

  return (
    <Switch>
      <Route exact path="/">
        <AutoRedirect />
      </Route>
      {/* Events Analytics merged into the Analytics page as a tab. */}
      <Redirect exact from="/events_analytics" to="/analytics" />
      {mapItemsAsRoutes(simpleRoutes)}
    </Switch>
  );
};

export default React.memo(Routes) as typeof Routes;
export { getRoutes } from './getRoutes';
export { useExternals } from './useExternals';
